import { DOC_CODE,
  DOC_NAME,
  DESCRIPTION,
  IS_REQUIRED,
  DISPLAY_ORDER,
  FILE_TYPES,
  MAX_FILE_SIZE,
  STATUS, 
  OCP_STAGE} from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { routes } from "@/routes/utils";
import { schema } from "./validations";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";
import { FormCheckbox, FormInput, FormSelect } from "@/components";
import { fileTypeOptions, ocpStageOption } from "@/lib/utils";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "OCP Document Types",
    moduleRoute: `${routes.masterData}/${routes.ocpDocTypes}`,
    schema,
    defaultValues: { 
      [DOC_CODE]: "",
      [DOC_NAME]: "",
      [DESCRIPTION]: "",
      [IS_REQUIRED]: false,
      [DISPLAY_ORDER]: "",
      [FILE_TYPES]: "",
      [OCP_STAGE]: "",
      [MAX_FILE_SIZE]: "",
      [STATUS]: true,
    },
    nameFieldKey: DOC_NAME,
    queryKeyToInvalidate: "ocp-document-types",
    module: "ocp-document-types",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  const { form, requiredFields } = addEditHook;
  const { errors } = form.formState;
  console.log("🚀 ~ AddEdit ~ errors:", errors)

  const customFields = (
    <>
      <FormInput
        name={DOC_CODE}
        control={form.control}
        label="Document Code"
        placeholder="Please enter"
        error={errors[DOC_CODE]?.message}
        isRequired={requiredFields.includes(DOC_CODE)}
      />
      <FormSelect
        name={OCP_STAGE}
        control={form.control}
        label="OCP Stage"
        placeholder="Please enter"
        error={errors[FILE_TYPES]?.message}
        isRequired={requiredFields.includes(FILE_TYPES)}
        options={ocpStageOption}
      />
      <FormSelect
        multiSelect
        name={FILE_TYPES}
        control={form.control}
        label="File Types"
        placeholder="Please enter"
        error={errors[FILE_TYPES]?.message}
        isRequired={requiredFields.includes(FILE_TYPES)}
        options={fileTypeOptions}
      />
      <FormInput
        name={MAX_FILE_SIZE}
        control={form.control}
        label="Max File Size"
        placeholder="Please enter"
        error={errors[MAX_FILE_SIZE]?.message}
        isRequired={requiredFields.includes(MAX_FILE_SIZE)}
        variant="integer"
      />
      <FormInput
        name={DISPLAY_ORDER}
        control={form.control}
        label="Display Order"
        placeholder="Please enter"
        error={errors[DISPLAY_ORDER]?.message}
        isRequired={requiredFields.includes(DISPLAY_ORDER)}
        variant="integer"
      />
      <FormCheckbox
        name={IS_REQUIRED}
        control={form.control}
        label="Is Required"
        placeholder="Please enter"
        error={errors[IS_REQUIRED]?.message}
        isRequired={requiredFields.includes(IS_REQUIRED)}
      />
    </>
  )

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Document Name"
      customFields={customFields}
    />
  );
};

export default AddEdit;
